<div class="box-1 pos-sticky" style="display: flex; justify-content: space-between;">
  <p-panel [toggleable]="true" [style]="{width: '100%', marginBottom: '20px'}" expandIcon="pi pi-chevron-up" collapseIcon="pi pi-chevron-down">
    <ng-template pTemplate="header">
      <div class="main-flex-box">
        <div>
          <div class="main-headings">
            <h1 class="text-1">Data Explorer</h1>
            <div class="white-box">
              <div>
                <p class="m-0 db-name">DB Name:</p>
              </div>
              <div>
                <p class="m-0 db-name-desc">{{databaseName}}</p>
              </div>
            </div>
            <div class="white-box">
              <div>
                <p class="m-0 db-name">Server:</p>
              </div>
              <div>
                <p class="m-0 db-name-desc">{{connectionString | slice:0:35}}</p>
              </div>
            </div>
            <div class="other-box" [ngClass]="{'selected': isInShowUniversalSearchMode}">
              <i class="pi pi-globe" style="cursor:pointer !important;" (click)="showUniversalSearchModal()"></i>
            </div>
            <div class="other-box" [ngClass]="{'selected': isInShowUniversalSoftDeleteSearchMode}">
              <i class="pi pi-trash" style="cursor:pointer !important;" (click)="showUniversalSoftDeleteSearchModal()"></i>
            </div>
            <div class="other-box" [ngClass]="{'selected': isInShowUniversalJoinsMode}">
              <i class="pi pi-sitemap" style="cursor:pointer !important;" (click)="showUniversalJoinsModal()"></i>
            </div>
            <div class="other-box" [ngClass]="{'selected': isInShowUniversalSimilaritiesMode}">
              <i class="pi pi-clone" style="cursor:pointer !important;" (click)="showUniversalSimilaritiesModal()"></i>
            </div>
          </div>
        </div>
        <div class="search-input-container">
          <div class="rounded-button-filter-white">
            <span class="p-input-icon-left" style="height: 100%;">
              <i class="pi pi-search"></i>
              <input type="text" placeholder="Search Tables" class="search-input w-100" pInputText />

            </span>
          </div>
        </div>
      </div>
    </ng-template>
    <div class="box-1" style="display: flex; justify-content: space-between; flex-wrap: wrap; gap: 15px;">
      <div class="d-flex gap-3">
        <div [ngClass]="isAllTableCountSelected ? 'rounded-button-filter' : 'rounded-button-filter-white'" (click)="showFilteredTables('all')">
          <p-button>
            <span>All</span>
            <div class="btn-round">{{all_tableCount}} tables</div>
          </p-button>
        </div>

        <div [ngClass]="is_A_to_E_TableCountSelected ? 'rounded-button-filter' : 'rounded-button-filter-white'" (click)="showFilteredTables('a_to_e')">
          <p-button>
            <span>A-E</span>
            <div class="btn-round">{{a_to_e_tableCount}} tables</div>
          </p-button>
        </div>

        <div [ngClass]="is_F_to_J_TableCountSelected ? 'rounded-button-filter' : 'rounded-button-filter-white'" (click)="showFilteredTables('f_to_j')">
          <p-button>
            <span>F-J</span>
            <div class="btn-round-gray">{{f_to_j_tableCount}} tables</div>
          </p-button>
        </div>

        <div [ngClass]="is_K_to_O_TableCountSelected ? 'rounded-button-filter' : 'rounded-button-filter-white'" (click)="showFilteredTables('k_to_o')">
          <p-button>
            <span>K-O</span>
            <div class="btn-round-gray">{{k_to_o_tableCount}} tables</div>
          </p-button>
        </div>

        <div [ngClass]="is_P_to_T_TableCountSelected ? 'rounded-button-filter' : 'rounded-button-filter-white'" (click)="showFilteredTables('p_to_t')">
          <p-button>
            <span>P-T</span>
            <div class="btn-round-gray">{{p_to_t_tableCount}} tables</div>
          </p-button>
        </div>

        <div [ngClass]="is_U_to_Z_TableCountSelected ? 'rounded-button-filter' : 'rounded-button-filter-white'" (click)="showFilteredTables('u_to_z')">
          <p-button>
            <span>U-Z</span>
            <div class="btn-round-gray">{{u_to_z_tableCount}} tables</div>
          </p-button>
        </div>
      </div>

      <div class="d-flex position-set">

        <!-- Save view modal  -->
        <app-save-view-modal *ngIf="isSaveViewModal"
                             [isSaveViewModalVisible]="isSaveViewModal"
                             [viewName]="currentSavedView"
                             (viewNameEnteredEventEmitter)="handleViewNameSaved($event)"></app-save-view-modal>

        <!-- Save View -->
        <p-button class="rounded-button-white mr colorGreen" *ngIf="isViewMode" (click)="saveView()" label="Save View" icon="pi pi-save"></p-button>

        <!-- See Saved View -->
        <p-button class="rounded-button-white mr" *ngIf="isViewMode" (click)="seeAllViewTables()" label="View tables" icon="pi pi-table"></p-button>
        <!-- (#) Tables in View -->
        <p-button class="rounded-button-white mr" (click)="tabInViewOverlay.toggle($event)" label="({{tablesInViewCount}}) Tables in View" icon="pi pi-filter">
        </p-button>

        <p-button class="rounded-button-white mr" (click)="seeSavedViews()" label="Saved Views" icon="pi pi-list">
        </p-button>

      </div>
    </div>
  </p-panel>
</div>

<div *ngIf="isShowUniversalSearchModal">
  <app-universal-search-modal [columns]="allTableColumns"
                              (dialogCloseEmitter)="dialogCloseEmitter($event)"
                              (beginUniversalSearch)="beginUniversalSearch($event)"></app-universal-search-modal>
</div>

<div *ngIf="isShowUniversalSoftDeleteSearchModal">
  <app-universal-softdelete-search-modal [columns]="allTableColumns"
                                         (dialogCloseEmitter)="dialogCloseEmitter($event)"
                                         (beginUniversalSoftDeleteSearch)="beginUniversalSoftDeleteSearch($event)"></app-universal-softdelete-search-modal>
</div>

<div *ngIf="isShowUniversalJoinsModal">
  <app-universal-joins-modal [columns]="allTableColumns"
                             (dialogCloseEmitter)="dialogCloseEmitter($event)"
                             (beginJoinsSearch)="beginJoinsSearch()"></app-universal-joins-modal>
</div>

<div *ngIf="isShowUniversalSimilaritiesModal">
  <app-universal-similarities-modal [columns]="allTableColumns"
                                    (dialogCloseEmitter)="dialogCloseEmitter($event)"
                                    (beginSimilaritiesSearch)="beginSimilaritiesSearch($event)"></app-universal-similarities-modal>
</div>
<!-- Mini tables -->
<div *ngIf="!skeleton" class="card box-2">
  <div class="grid" style="overflow-x: auto;" [ngClass]="showFilterModal ? 'vh-88' : ''">
    <div class="row pb-27">
      <div *ngFor="let table of viewableTables index as i"
           class="col-4 md:col-4 lg:col-4 pb-10">
        <p-panel [toggleable]="true"
                 class="custom-panel"
                 collapseIcon="pi pi-plus"
                 expandIcon="pi pi-minus"
                 [collapsed]="isCollapsed">
          <ng-template pTemplate="header">
            <!-- <span class="icon-container-logo">
              <img alt="data-table-icon" src="../../../../../assets/images/svg/database-icon.svg"
                style="width: 1.5rem" />
            </span> -->
            <div class="card-head-icons">
              <div class="heading-title">
                <span class="title"
                      style="flex-basis:200px">
                  &nbsp; {{table?.schema}}.{{table?.name}} <i *ngIf="table.IsShowJoins" class="pi pi-sitemap"
                                                              style="cursor:pointer !important; color:red !important;"
                                                              (click)="showUniversalJoinsModal()"></i>
                  &nbsp;
                  <p-badge *ngIf="table.IsShowJoins" value="{{table.JoinCount}}"></p-badge>
                </span>
              </div>
              <div class="card-head-icons-list">
                <span class="icon-container" *ngIf="!isTableInView(table)" (click)="addTableToView(table)">
                  <i class="pi pi-save hand-cursor" style="font-size: 0.9rem; color: #669BBC; font-weight: 900;"></i>
                </span>
                <span class="icon-container" *ngIf="isViewMode && isTableInView(table)" (click)="removeTableFromView(table)"
                      style="background-color: red;">
                  <i class="pi pi-trash hand-cursor" style="font-size: 0.9rem; color: #669BBC; font-weight: 900;"></i>
                </span>

                <div style="position: relative;" *ngIf="table?.filtered">
                  <span class="icon-container" (click)="clearFilterData(table)">
                    <i class="pi pi-filter-slash hand-cursor" style="font-size: 0.9rem; color: #669BBC; font-weight: 900;"></i>
                  </span>
                  <div style="position: absolute; z-index: 9;" [ngStyle]="{left: i%3 == 2? '-320px':null}" id="filter-alignment" class="mt-3">
                  </div>
                </div>

                <div style="position: relative;">
                  <span [ngClass]="table?.filtered ? 'icon-container selected-filter' : 'icon-container'" (click)="toggleFilterModal(table)">
                    <i class="pi pi-filter hand-cursor" style="font-size: 0.9rem; color: #669BBC; font-weight: 900;"></i>
                  </span>
                  <div style="position: absolute; z-index: 9;" [ngStyle]="{left: i%3 == 2? '-320px':null}" id="filter-alignment" class="mt-3">
                    <app-filter-modal *ngIf="resultMatch?.name === table?.name && showFilterModal"
                                      [visible]="resultMatch?.name === table?.name"
                                      [columns]="tableColumnsForFilter"
                                      [filterCondition]="table?.condition"
                                      (applyFilterEventEmitter)="applyFilter($event)"></app-filter-modal>
                  </div>
                </div>

                <span class="icon-container" (click)="showTableViewDialog(table)">
                  <i class="pi pi-eye hand-cursor" style="font-size: 0.9rem; color: #669BBC; font-weight: 900;"></i>
                </span>
              </div>
            </div>
          </ng-template>

          <div style="overflow-x: auto; max-height:15em"
               #scrollableElement
               *ngIf="filterSkeleton === table?.name">
            <table>
              <thead>
                <tr>
                  <th>Audit Type</th>
                  <th>AuditID</th>
                  <th>Modified By</th>
                  <th>Modified Date</th>
                  <th></th>
                </tr>
              </thead>
              <tr class="bg-evenly">
                <td><app-skeleton [skeleton]="{width:'100%',height:'2rem',count:[1,2,3,4,5],class:'mt-1'}"></app-skeleton></td>
                <td><app-skeleton [skeleton]="{width:'100%',height:'2rem',count:[1,2,3,4,5],class:'mt-1'}"></app-skeleton></td>
                <td><app-skeleton [skeleton]="{width:'100%',height:'2rem',count:[1,2,3,4,5],class:'mt-1'}"></app-skeleton></td>
                <td><app-skeleton [skeleton]="{width:'100%',height:'2rem',count:[1,2,3,4,5],class:'mt-1'}"></app-skeleton></td>
              </tr>
            </table>
          </div>

          <div style="overflow-x: auto; max-height:15em"
               *ngIf="filterSkeleton != table?.name"
               (scroll)="onScroll($event, table.schema, table.name)">
            <table [id]="table.name + '_data'">
              <thead>
                <tr>
                  <th (click)="sortData(table, 'AuditType')">Audit Type <i class="pi" [ngClass]="getSortIcon(table, 'AuditType')"></i></th>
                  <th (click)="sortData(table, 'AuditId')">Audit ID <i class="pi" [ngClass]="getSortIcon(table, 'AuditId')"></i></th>
                  <th (click)="sortData(table, 'ModifiedBy')">Modified By <i class="pi" [ngClass]="getSortIcon(table, 'ModifiedBy')"></i></th>
                  <th (click)="sortData(table, 'ModifiedDate')">Modified Date <i class="pi" [ngClass]="getSortIcon(table, 'ModifiedDate')"></i></th>
                  <ng-container *ngFor="let column of table.data[0]?.TableColumns">
                    <th (click)="sortData(table, column.Name)">
                      {{ column.Name }}
                      <i class="pi" [ngClass]="getSortIcon(table, column.Name)"></i>
                      <p-badge *ngIf="column.IsShowSimilarityBadge" value="{{column.ColumnSimilarityCount}}"></p-badge>
                      <!--<p-badge value="99"></p-badge>-->
                      <i *ngIf="table.IsJoinColumn" class="pi pi-sitemap"
                         style="cursor:pointer !important; color:red !important;"
                         (click)="showUniversalJoinsModal()"></i>
                      <p-badge *ngIf="column.IsShowJoinBadge" value="{{column.ColumnJoinCount}}"></p-badge>
                    </th>
                  </ng-container>
                </tr>
              </thead>
              <tr class="bg-evenly" *ngFor="let tableRecord of table.data">
                <td>{{tableRecord.AuditType}}</td>
                <td>{{tableRecord.AuditId}}</td>
                <td> <span [ngClass]="table.data[0].modifiedBy ? 'red-box' : ''">{{tableRecord.ModifiedBy}}</span></td>
                <td>{{tableRecord.ModifiedDate}}</td>
                <td *ngFor="let tableColumn of tableRecord.TableColumns">{{tableColumn.Value}}</td>
              </tr>

            </table>
          </div>
        </p-panel>
      </div>
    </div>
  </div>
</div>

<div *ngIf="skeleton">
  <div class="card box-2">
    <div class="grid" style="overflow-x: auto;">
      <div class="row pb-27">
        <div class="col-4 md:col-4 lg:col-4 pb-10">
          <p-panel [toggleable]="false"
                   collapseIcon="pi pi-plus"
                   expandIcon="pi pi-minus"
                   [collapsed]="isCollapsed">
            <ng-template pTemplate="header">
              <app-skeleton [skeleton]="{width:'100%',height:'2rem',count:[1],class:'mt-1'}"></app-skeleton>
            </ng-template>
            <div style="overflow-x: auto; max-height:15em">
              <table>
                <thead>
                  <tr>
                    <th>Audit Type</th>
                    <th>AuditID</th>
                    <th>Modified By</th>
                    <th>Modified Date</th>
                    <th></th>
                  </tr>
                </thead>
                <tr class="bg-evenly">
                  <td><app-skeleton [skeleton]="{width:'100%',height:'2rem',count:[1,2,3,4,5],class:'mt-1'}"></app-skeleton></td>
                  <td><app-skeleton [skeleton]="{width:'100%',height:'2rem',count:[1,2,3,4,5],class:'mt-1'}"></app-skeleton></td>
                  <td><app-skeleton [skeleton]="{width:'100%',height:'2rem',count:[1,2,3,4,5],class:'mt-1'}"></app-skeleton></td>
                  <td><app-skeleton [skeleton]="{width:'100%',height:'2rem',count:[1,2,3,4,5],class:'mt-1'}"></app-skeleton></td>
                </tr>
              </table>
            </div>
          </p-panel>

        </div>
        <div class="col-4 md:col-4 lg:col-4 pb-10">
          <p-panel [toggleable]="false"
                   collapseIcon="pi pi-plus"
                   expandIcon="pi pi-minus"
                   [collapsed]="isCollapsed">


            <ng-template pTemplate="header">
              <app-skeleton [skeleton]="{width:'100%',height:'2rem',count:[1],class:'mt-1'}"></app-skeleton>
            </ng-template>
            <div style="overflow-x: auto; max-height:15em">
              <table>
                <thead>
                  <tr>
                    <th>Audit Type</th>
                    <th>AuditID</th>
                    <th>Modified By</th>
                    <th>Modified Date</th>
                    <th></th>
                  </tr>
                </thead>
                <tr class="bg-evenly">
                  <td><app-skeleton [skeleton]="{width:'100%',height:'2rem',count:[1,2,3,4,5],class:'mt-1'}"></app-skeleton></td>
                  <td><app-skeleton [skeleton]="{width:'100%',height:'2rem',count:[1,2,3,4,5],class:'mt-1'}"></app-skeleton></td>
                  <td><app-skeleton [skeleton]="{width:'100%',height:'2rem',count:[1,2,3,4,5],class:'mt-1'}"></app-skeleton></td>
                  <td><app-skeleton [skeleton]="{width:'100%',height:'2rem',count:[1,2,3,4,5],class:'mt-1'}"></app-skeleton></td>
                </tr>
              </table>
            </div>
          </p-panel>

        </div>
        <div class="col-4 md:col-4 lg:col-4 pb-10">
          <p-panel [toggleable]="false"
                   collapseIcon="pi pi-plus"
                   expandIcon="pi pi-minus"
                   [collapsed]="isCollapsed">


            <ng-template pTemplate="header">
              <app-skeleton [skeleton]="{width:'100%',height:'2rem',count:[1],class:'mt-1'}"></app-skeleton>
            </ng-template>
            <div style="overflow-x: auto; max-height:15em">
              <table>
                <thead>
                  <tr>
                    <th>Audit Type</th>
                    <th>AuditID</th>
                    <th>Modified By</th>
                    <th>Modified Date</th>
                    <th></th>
                  </tr>
                </thead>
                <tr class="bg-evenly">
                  <td><app-skeleton [skeleton]="{width:'100%',height:'2rem',count:[1,2,3,4,5],class:'mt-1'}"></app-skeleton></td>
                  <td><app-skeleton [skeleton]="{width:'100%',height:'2rem',count:[1,2,3,4,5],class:'mt-1'}"></app-skeleton></td>
                  <td><app-skeleton [skeleton]="{width:'100%',height:'2rem',count:[1,2,3,4,5],class:'mt-1'}"></app-skeleton></td>
                  <td><app-skeleton [skeleton]="{width:'100%',height:'2rem',count:[1,2,3,4,5],class:'mt-1'}"></app-skeleton></td>
                </tr>
              </table>
            </div>
          </p-panel>

        </div>
      </div>
    </div>
  </div>
</div>


<div class="d-flex gap-3 success-message">
  <p-messages [(value)]="messages" [enableService]="false"></p-messages>
  <p-messages [(value)]="errorMessage" [enableService]="false"></p-messages>
</div>


<div class="d-flex gap-3 collapse-button" *ngIf="viewableTables?.length">
  <div [ngClass]="isAllTableCountSelected ? 'rounded-button-filter' : 'rounded-button-filter-white'">
    <p-button (click)="collapseExpandTables()">
      <i [ngClass]="isCollapsed? 'pi pi-angle-double-down': 'pi pi-angle-double-up'"></i>
      <div class="btn-round">{{isCollapsed? 'Expand all': 'collapse all'}}</div>
    </p-button>
  </div>
</div>

<ng-container *ngIf="visible">
  <app-data-table-view-modal *ngIf="dataTableview" [dataTableview]="dataTableview" (valueChange)="close($event)"></app-data-table-view-modal>
</ng-container>


<!-- view table list pop/modal -->
<div class="view-data-list">
  <p-overlayPanel #tabInViewOverlay [style]="{ width: '15%' }" [showCloseIcon]="true">
    <ng-template pTemplate="content">
      <h5 class="m-l-21">{{tablesInViewCount}} Tables in view </h5>
      <div *ngFor="let table of tablesInView" class="view-data">
        <span class="span">{{table.name}}</span> <i (click)="removeFromTablesInView(table)" class="pi pi-times chip-icon"></i>
      </div>
    </ng-template>
  </p-overlayPanel>

  <!-- <p-dialog header="({{tablesInViewCount}}) Tables in view" [modal]="true" [(visible)]="dataView">

  </p-dialog> -->
</div>

<!--
////////loader comp.. here//////////
<app-global-loader *ngIf="skeleton"></app-global-loader> -->
